import React, { useState } from "react";
import {
  FaPhone,
  FaWhatsapp,
  FaEnvelope,
  FaBars,
  FaTimes,
} from "react-icons/fa";

const ContactButtons = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const contactButtons = [
    {
      icon: <FaPhone size={24} />,
      href: "tel:3155067905",
      label: "Llamar",
      bgColor: "bg-blue-500",
      hoverColor: "hover:bg-blue-600",
    },
    {
      icon: <FaWhatsapp size={24} />,
      href: "https://wa.me/573155067905",
      label: "WhatsApp",
      bgColor: "bg-green-500",
      hoverColor: "hover:bg-green-600",
      isExternal: true,
    },
    {
      icon: <FaEnvelope size={24} />,
      href: "mailto:contacto@huakar.com",
      label: "Email",
      bgColor: "bg-red-500",
      hoverColor: "hover:bg-red-600",
    },
  ];

  return (
    <>
      {/* Mobile Menu */}
      <div className="md:hidden">
        {/* Hamburger Button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="fixed bottom-6 right-6 z-50 bg-blue-700 text-white p-4 rounded-full shadow-lg hover:bg-gray-700 transition-colors"
        >
          {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>

        {/* Mobile Menu Panel */}
        <div
          className={`fixed bottom-0 left-0 right-0 bg-white shadow-lg rounded-t-3xl transform transition-transform duration-300 ease-in-out z-40 ${
            isMenuOpen ? "translate-y-0" : "translate-y-full"
          }`}
        >
          <div className="px-4 py-8">
            <h2 className="text-2xl font-bold mb-6 text-center">Contáctanos</h2>
            {contactButtons.map((button, index) => (
              <a
                key={index}
                href={button.href}
                target={button.isExternal ? "_blank" : undefined}
                rel={button.isExternal ? "noopener noreferrer" : undefined}
                className={`flex items-center gap-3 p-4 ${button.bgColor} ${button.hoverColor} text-white rounded-lg transition-colors w-full mb-2`}
                onClick={() => setIsMenuOpen(false)}
              >
                {button.icon}
                <span className="text-lg">{button.label}</span>
              </a>
            ))}
          </div>
        </div>

        {/* Overlay */}
        {isMenuOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-30"
            onClick={() => setIsMenuOpen(false)}
          />
        )}
      </div>

      {/* Desktop/Tablet Buttons */}
      <div className="hidden md:block">
        {contactButtons.map((button, index) => (
          <a
            key={index}
            href={button.href}
            target={button.isExternal ? "_blank" : undefined}
            rel={button.isExternal ? "noopener noreferrer" : undefined}
            className={`fixed right-6 ${button.bgColor} ${button.hoverColor} text-white p-4 rounded-full shadow-lg transition-colors z-50`}
            style={{
              bottom: `${(index + 1) * 5 + index * 3}rem`,
            }}
          >
            {button.icon}
          </a>
        ))}
      </div>
    </>
  );
};

export default ContactButtons;
